<div class="mat-modal-wrapper">
	<app-ehe-verification-modal
		(action)="actionFunction($event, data.documentKey)"
		[title]="'Delete Document?'"
		[button1]="'Delete'"
		[button2]="'Cancel'">
		<div class="delete-wrapper">
			<div class="row justify-content-center">
				<div class="col-md-12">
					<p class="w-100">Caution: This cannot be undone</p>
				</div>
			</div>
		</div>
	</app-ehe-verification-modal>
</div>
